import { Directive, Injectable, Input, EventEmitter, Output, ElementRef, HostListener, inject } from '@angular/core';

import * as _ from 'lodash';

@Directive({
    selector: '[appScrollSpy]'
})
export class ScrollSpyDirective {
    private _el = inject(ElementRef);

    @Input() public querySelector = '';
    @Output() public sectionChange = new EventEmitter<string>();
    private currentSection: string;


    constructor() {}

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        const children = this._el.nativeElement.querySelectorAll(this.querySelector);
        const scrollTop = event.target.scrollTop;
        const parentOffset = event.target.offsetTop;

        const sectionsAbove = _.filter(children, child => ((child.offsetTop - parentOffset) <= scrollTop));

        if (sectionsAbove.length > 0) {
            const section = _.last(sectionsAbove);
            this.currentSection = section.id;

            this.sectionChange.emit(this.currentSection);
        }
    }
}
